module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/ac5821468dbe5651c9a31f58eeb4f593.svg";